export const FEEDBACK_URL = 'feedback'
export const FEEDBACK_DETAIL_URL = 'feedback-detail'

export const FEEDBACK_TRANSACTION_PATH = `/project/:id/${FEEDBACK_URL}`
export const FEEDBACK_DETAIL_TRANSACTION_PATH = `/project/:id/${FEEDBACK_URL}/:feedbackId`
